import { ActionTypes } from "../constants/actionTypes";

export const setConnectedAccounts = (data) => {
  return {
    type: ActionTypes.SET_CONNECTEDACCOUNTS,
    payload: data,
  };
};
